"use client";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { BookingForm } from "./BookingForm";
import { Booking } from "@/lib/types";

interface BookingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultService?: string;
  isManual?: boolean;
  onSuccess?: () => void;
  // Kept for backward compatibility with the dashboard's existing
  // "Book Follow Up" entry point — see useBookingForm for details.
  initialData?: Booking | null;
  // No longer used (the old slot-locking behavior they powered is gone),
  // kept only so existing callers don't break the build before Batch 3.
  minDate?: Date;
  minTime?: string;
}

/**
 * BookingModal Component
 * A dialog wrapper for the booking form.
 */
export function BookingModal({
  open,
  onOpenChange,
  defaultService,
  isManual,
  onSuccess,
  initialData,
}: BookingModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-h-[90vh] w-full overflow-y-auto p-6 sm:max-w-[540px]"
        onOpenAutoFocus={(e) => e.preventDefault()}
        aria-describedby="booking-description"
      >
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {isManual ? "Add Manual Booking" : "Book an Appointment"}
          </DialogTitle>
          <DialogDescription id="booking-description">
            {isManual
              ? "Enter patient details to create a manual booking."
              : "Fill in your details and we'll confirm your appointment shortly."}
          </DialogDescription>
        </DialogHeader>
        <BookingForm
          key={initialData?._id || "new"}
          defaultService={defaultService || initialData?.service}
          isManual={isManual}
          initialData={initialData}
          onSuccess={() => {
            onSuccess?.();
            onOpenChange(false);
          }}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
